import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ExternalLink, Star } from 'lucide-react';
import ToolSteps from './ToolSteps';
import { getToolsByCategory } from '../data/toolsData';

export default function ToolRecommendations({ useCase }) {
  const tools = getToolsByCategory(useCase);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Top AI Tools for {useCase}</CardTitle>
        <CardDescription>
          Hand-picked tools perfectly matched to your use case. Click to explore each tool.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {tools.map((tool, index) => (
            <Card key={index} className="border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-md">
              <CardContent className="pt-6 pb-6">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-start gap-3 mb-2">
                      <div>
                        <h3 className="text-lg font-semibold mb-1">{tool.name}</h3>
                        <div className="flex items-center gap-2 mb-2">
                          <Badge variant="secondary" className="text-xs">{tool.category}</Badge>
                          <div className="flex items-center gap-1 text-sm text-muted-foreground">
                            <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
                            <span>{tool.rating}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {tool.description}
                    </p>
                  </div>
                  <Button className="gap-2 flex-shrink-0 w-full lg:w-auto" onClick={() => window.open(tool.url, '_blank')}>
                    Visit Tool
                    <ExternalLink className="w-4 h-4" />
                  </Button>
                </div>
                <ToolSteps tool={tool} />
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
